<template>
	<div class="container_page">
		<!--  -->
		<div class="filter_box">
			<div class="flex">
				<a-input v-model="filterData.keywords" style="width: 300px" class="mr12"
					placeholder="请输入国家名称"></a-input>
				<a-button class="mr12" type="primary" @click="toSearch(true)">搜索</a-button>
				<a-button class="mr12"  @click="toSearch(false)">清空</a-button>
				<a-button class="mr12" type="primary" @click="toAdd">新增</a-button>
			</div>
			<span></span>
		</div>
		
		<a-table :columns="columns" :data-source="tableData" :pagination="pageInfo" @change="changePage"
			:loading="loading">
			<template slot="nationalFlagUrl" slot-scope="text, record">
				<!-- <div v-if="record.nationalFlagUrl !== null">
					<img :src="record.nationalFlagUrl" alt="" style="width: 100px;height: 100px"
						@click="toSeeImg(record)" />
				</div>
				<div v-else>-</div> -->

				<viewer :images="[record.nationalFlagUrl]" >
					<div class="er_content">
						<img class="er_content_img" :src="img" v-for="(img,index) in [record.nationalFlagUrl]" :key="index" >
					</div>
				</viewer>
			</template>

			

			<template slot="action" slot-scope="text, record">
				<div class="flex_center">
					<a-button type="link" @click="toEdit(record)">编辑</a-button>
					<a-button type="link" @click="toDelete(record)">删除</a-button>
				</div>
			</template>
		</a-table>
		<a-modal :visible="imgModel.flag" width="880px" :closable="false" maskClosable :destroyOnClose="true">
			<template slot="footer">
				<a-button @click="imgModel.flag = false">关闭</a-button>
			</template>
			<span>
				<img :src="imgModel.url" alt="" style="width: 800px;height: 296px" />
			</span>
		</a-modal>
		<a-modal :title="tipsModel.title" :visible="tipsModel.flag" @ok="tipsModel.onOk"
			@cancel="tipsModel.flag = false">
			<span>
				{{ tipsModel.content }}
			</span>
		</a-modal>
		<a-modal :title="editModel.title" :visible="editModel.flag" width="700px" @ok="editModel.onOk"
			@cancel="editModel.flag = false">
			<a-form-model :model="editModel" :label-col="labelCol" :wrapper-col="wrapperCol">
				<a-row>
					<a-col :span="20">
						<a-form-model-item label="图标">
							<!-- (长宽比例为1080：400) -->
							<div v-if="editModel.nationalFlagUrl">

								<viewer :images="[editModel.nationalFlagUrl]" >
									<div class="er_content">
										<img class="er_content_img" :src="img" v-for="(img,index) in [editModel.nationalFlagUrl]" :key="index" >
									</div>
								</viewer>

								<!-- <img :src="editModel.nationalFlagUrl" alt="" style="width: 40px;height: 40px" /> -->
							</div>

							<div class="again_upload_box ml12">
								<input type="file" accept="image/" @change="handleUpdataFile" />
								<i class="el-icon-box again_upload_icon"></i>
								<div class="bold" style="width: 100px">上传文件</div>
							</div>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="20">
						<a-form-model-item label="国家">
							<a-input v-model="editModel.name" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="20">
						<a-form-model-item label="货币单位">
					<a-input v-model="editModel.currencyCode" />
				</a-form-model-item>
						
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="20">
						<a-form-model-item label="序号">
					<a-input v-model="editModel.sort" />
				</a-form-model-item>
						
					</a-col>
				</a-row>
			</a-form-model>


		</a-modal>
	</div>
</template>

<script>
	import {
		getCountryApi,
		setCountryApi,
		deleteCountryApi,
		getOssAuth,
	} from "../../api/index";
	export default {
		name: "settingCountryList",
		data() {
			return {
				columns: [{
						title: "ID",
						key: "countryId",
						dataIndex: "countryId",
					},
					{
						title: "国家名称",
						key: "name",
						dataIndex: "name",
					},
					{
						title: "图标",
						key: "nationalFlagUrl",
						scopedSlots: {
							customRender: "nationalFlagUrl"
						},
					},
					{
						title: "货币单位",
						dataIndex: "currencyCode",
						key: "currencyCode",
					},
					{
						title: "序号",
						dataIndex: "sort",
						key: "sort",
					},
					{
						title: "创建日期",
						dataIndex: "createTime",
						key: "createTime",
					},
					{
						title: "操作",
						key: "action",
						width: 300,
						scopedSlots: {
							customRender: "action"
						},
					},
				],
				filterData: {
					keywords: "",
				},
				tableData: [],
				pageInfo: {
					pageSize: 20,
					current: 1,
					total: 0,
					showTotal: (total, range) => {
						return `合计 ${total} 条记录`;
					},
				},
				loading: false,
				imgModel: {
					flag: false,
					url: "",
				},
				tipsModel: {
					flag: false,
					title: "",
					content: "",
					countryId: '',
					onOk: () => {},
				},
				editModel: {
					flag: false,
					title: "",
					name: '',
					nationalFlagUrl: "",
					sort: "",
					countryId: '',
					currencyCode:"",
					onOk: () => {},
				},
				formState: {
					"nationalFlagUrl": "", //卡片图标
					"name": "", //卡片名称
					"sort": 1 //序号
				},
				labelCol: {
					span: 4
				},
				wrapperCol: {
					span: 18
				},
			};
		},
		created() {},
		activated() {},
		mounted() {
			const storedQuery = localStorage.getItem('settingCountryList_searchQuery');
			if(storedQuery){
				this.filterData = JSON.parse(storedQuery);
				this.getData(1);
			} else {
				this.getData(1);
			}
		},
		beforeRouteLeave(to, from, next) {
			localStorage.setItem('settingCountryList_searchQuery', JSON.stringify(this.filterData));
			next();
		},
		methods: {
			toSearch(flag) {
				if (flag) {
					this.getData(1);
				} else {
					this.filterData = {
						keywords: "",
					};
					this.getData(1);
				}
			},
			changePage(page) {
				this.pageInfo.current = page.current;
				this.getData(this.pageInfo.current);
			},
			getData(page = 1) {
				this.pageInfo.current = page;
				if (this.loading) {
					return;
				}
				this.loading = true;
				getCountryApi({
						pageNo: this.pageInfo.current,
						pageSize: this.pageInfo.pageSize,
						keywords: this.filterData.keywords
					})
					.then((res) => {
						if (res.resultStatus) {
							this.tableData = res.resultData.dataList || [];
							this.pageInfo.total = res.resultData.totalNum || 0;

						} else {
							this.tableData = [];
							this.pageInfo.total = 0;
						}
					})
					.catch((err) => {
						console.error(err);
					})
					.finally(() => {
						this.loading = false;
					});
			},
			toAdd() {
				this.editModel = {
					flag: true,
					title: "新增",
					countryId: 0,
					nationalFlagUrl: "",
					name: '',
					currencyCode:'',
					sort: this.pageInfo.total + 1,
					onOk: this.sureEdit,
				};
			},
			toEdit(data) {
				this.editModel = {
					flag: true,
					title: "编辑",
					countryId: data.countryId,
					nationalFlagUrl: data.nationalFlagUrl,
					sort: data.sort,
					name: data.name,
					currencyCode:data.currencyCode,
					onOk: this.sureEdit,
				};
			},
			confirm() {

			},
			sureEdit() {
				setCountryApi({
						name: this.editModel.name,
						nationalFlagUrl: this.editModel.nationalFlagUrl,
						sort: this.editModel.sort,
						countryId: this.editModel.countryId,
						currencyCode:this.editModel.currencyCode
					})
					.then((res) => {
						if (res.resultStatus) {
							// this.$message.success(
							//   this.editModel.bannerId ? "编辑成功" : "新增成功"
							// );
							this.editModel.flag = false;
						} else {
							console.log("res", res);
						}
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						this.getData()
					})
			},
			toDelete(data) {
				this.tipsModel = {
					flag: true,
					title: "删除",
					content: "确认要删除吗？",
					countryId: data.countryId,
					onOk: this.sureDelete,
				};
			},
			toSeeImg(data) {
				this.imgModel = {
					flag: true,
					url: data.nationalFlagUrl,
				};
			},
			sureDelete() {
				if (this.loading) {
					return;
				}
				this.loading = true;
				deleteCountryApi({
						countryId: this.tipsModel.countryId,
					})
					.then((res) => {
						if (res.resultStatus) {
							this.$message.success("删除成功");
							this.tipsModel.flag = false;
						} else {
							console.log("res", res);
						}
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						this.loading = false;
						this.getData(1);
					});
			},
			// 上传文件
			handleUpdataFile(e) {
				if (e.target.files.length) {
					const file = e.target.files[0];
					console.log("file", file);
					if (file) {
						const form = new FormData();
						form.append("file", file);
						console.log("form", form);
						getOssAuth(form).then((res) => {
							if (res.resultStatus) {
								this.editModel.nationalFlagUrl = res.resultData.fileLink;
							}
						});
					}
				}
			},
		},
	};
</script>

<style lang="less">
	.container_page {
		padding: 20px;
		background: #ffffff;

		.filter_box {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 12px;
		}

		.mr12 {
			margin-right: 12px;
		}
	}
</style>